import { z } from 'zod';

import { InstagramCreatorInterest } from '@frontend/gql/social/graphql';

export const INSTAGRAM_CREATOR_INTEREST = {
  ANIMALS_AND_PETS: 'ANIMALS_AND_PETS',
  BOOKS_AND_LITERATURE: 'BOOKS_AND_LITERATURE',
  BUSINESS_FINANCE_AND_ECONOMICS: 'BUSINESS_FINANCE_AND_ECONOMICS',
  EDUCATION_AND_LEARNING: 'EDUCATION_AND_LEARNING',
  BEAUTY: 'BEAUTY',
  FASHION: 'FASHION',
  FITNESS_AND_WORKOUTS: 'FITNESS_AND_WORKOUTS',
  FOOD_AND_DRINK: 'FOOD_AND_DRINK',
  GAMES_PUZZLES_AND_PLAY: 'GAMES_PUZZLES_AND_PLAY',
  HISTORY_AND_PHILOSOPHY: 'HISTORY_AND_PHILOSOPHY',
  HOLIDAYS_AND_CELEBRATIONS: 'HOLIDAYS_AND_CELEBRATIONS',
  HOME_AND_GARDEN: 'HOME_AND_GARDEN',
  MUSIC_AND_AUDIO: 'MUSIC_AND_AUDIO',
  PERFORMING_ARTS: 'PERFORMING_ARTS',
  SCIENCE_AND_TECH: 'SCIENCE_AND_TECH',
  SPORTS: 'SPORTS',
  TV_AND_MOVIES: 'TV_AND_MOVIES',
  TRAVEL_AND_LEISURE_ACTIVITIES: 'TRAVEL_AND_LEISURE_ACTIVITIES',
  VEHICLES_AND_TRANSPORTATION: 'VEHICLES_AND_TRANSPORTATION',
  VISUAL_ARTS_ARCHITECTURE_AND_CRAFTS: 'VISUAL_ARTS_ARCHITECTURE_AND_CRAFTS',
} as const satisfies Record<string, InstagramCreatorInterest>;

export const InstagramCreatorInterestSchema = z.nativeEnum(INSTAGRAM_CREATOR_INTEREST);

export const INTEREST_DISPLAY_NAME_MAP: Record<InstagramCreatorInterest, string> = {
  ANIMALS_AND_PETS: 'Animals & Pets',
  BEAUTY: 'Beauty',
  BOOKS_AND_LITERATURE: 'Books & Literature',
  BUSINESS_FINANCE_AND_ECONOMICS: 'Business, Finance & Economics',
  EDUCATION_AND_LEARNING: 'Education & Learning',
  FASHION: 'Fashion',
  FITNESS_AND_WORKOUTS: 'Fitness & Workouts',
  FOOD_AND_DRINK: 'Food & Drink',
  GAMES_PUZZLES_AND_PLAY: 'Games, Puzzles & Play',
  HISTORY_AND_PHILOSOPHY: 'History & Philosophy',
  HOLIDAYS_AND_CELEBRATIONS: 'Holidays & Celebrations',
  HOME_AND_GARDEN: 'Home & Garden',
  MUSIC_AND_AUDIO: 'Music & Audio',
  PERFORMING_ARTS: 'Performing Arts',
  SCIENCE_AND_TECH: 'Science & Tech',
  SPORTS: 'Sports',
  TRAVEL_AND_LEISURE_ACTIVITIES: 'Travel & Leisure Activities',
  TV_AND_MOVIES: 'TV & Movies',
  VEHICLES_AND_TRANSPORTATION: 'Vehicles & Transportation',
  VISUAL_ARTS_ARCHITECTURE_AND_CRAFTS: 'Visual Arts, Architecture & Crafts',
};
